import { useMutation } from '@tanstack/react-query';
import * as _a from '@/lib/api';
import { createChannelPostComment } from '@/lib/api';

export const useCreateChannelPostComment = () => {
  return useMutation({
    mutationFn: _a.createChannelPostComment,
  });
};
